import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '@/utils/api'
import { API_ROUTES } from '@/const/apiRoutes'

export const usePathsStore = defineStore('paths', () => {
  const paths = ref<any>([])
  const isLoading = ref(false)
  const error = ref<string | null>(null)

  const fetchPaths = async () => {
    isLoading.value = true
    error.value = null

    try {
      const response = await api.get(API_ROUTES.GET_PATHS, {
        params: {
          page_size: 100
        }
      })
      paths.value = response.data.results
    } catch (err: any) {
      error.value = err.response?.data?.message || 'Failed to fetch paths'
      console.error('Error fetching paths:', err)
    } finally {
      isLoading.value = false
    }
  }

  return {
    paths,
    isLoading,
    error,
    fetchPaths,
  }
})